import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { InitializeStore } from "./app/initializeStore/InitializeStore";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <InitializeStore />
    <Suspense fallback={"Loading"}>
      <App />
    </Suspense>
  </Provider>
);

reportWebVitals();
